// import * as mutation from '../mutations';
import axios from 'axios';
import withDecrypt from '../../src/withDecrypt';
// import decorators from '../../src/api/decorators';
// import requestService from '../../src/api/services/requestService';
// import { home } from '../../src/api/queries';
// import { doHomePageAction } from '../../src/actions';
// import { actionConstants } from '../../src/constants';

async function fetchAPI(query, { variables, preview } = {}) {
  return axios({
    method: 'post',
    url: process.env.NEXT_PUBLIC_API_URL,
    data: {
      query,
    },
    // headers: { 'accessToken': args[0] },
  })
    .then(resp => withDecrypt(resp.data))
    .catch(err => {
      console.log(err);
    });
}

// const baseValue = {};

// const settings = (baseline = baseValue, payload = {}) => ({
//   ...baseline,
//   ...payload,
// });

// const theme = (baseline = baseValue, payload = {}) => {
//   const { type, chart_settings, series_settings, icon } = payload || {};

//   const { pallete, gradient } = payload.pallete ? JSON.parse(payload.pallete) : {};

//   return {
//     type,
//     chartSettings: chart_settings ? settings(undefined, JSON.parse(chart_settings)) : null,
//     pallete,
//     gradient,
//     seriesSettings: series_settings ? JSON.parse(series_settings) : null,
//     icon,
//   };
// };

export default async function getPlotData(queryData) {
  let queryStr = '';
  queryData.map((code, index) => {
    queryStr += `
      ${code.replace(/[\.\@\|\$\^\:]/g, '_')} :getData(code: "${code}"${queryData.limit ? `,limit: ${queryData.limit}` : ''}){
        type: __typename
        ... on Series_Data {
          code: seriesCode
          source
          ${queryData.detailOnly ? `desc: seriesDescription
          abbr: shortName`
        :
        `value
          recordDate
          rn`}
        }

        ... on Stock_Data {
          code: seriesCode
          source
          ${queryData.detailOnly ?
        `desc: description
          abbr: short_name`
        :
        `value: price
          recordDate: record_date
          rn`
      }
        }

        ... on Seq_Series_Data {
          code: seriesCode
          seq
          value
          desc
          source
        }
      },
    `;
  });
  const data = await fetchAPI(`
    query {
      ${queryStr}
    }
  `
  )
  return data
  // return [data].map(item => theme(undefined, item))[0];
}
